import { createContext, useContext } from "react";
/**
 * Create a side-effect-free context provider.
 */
class StyleSheetContextFactory {
  static Context() {
    return this.context = this.context || /*#__PURE__*/createContext({});
  }
}
StyleSheetContextFactory.context = void 0;
function useStylesheet() {
  return useContext(StyleSheetContextFactory.Context());
}
export { StyleSheetContextFactory, useStylesheet };